/**
 * The queues of Team Time Off's Leave Requests and TOIL Requests (HR Module Prototype, Component Map ›
 * Queue status): the decision statuses of requests still in the list, the archived ones, and all of them.
 * Archived replaced the Archived tab of Leave Manager and TOIL Manager.
 */
export const TIME_OFF_QUEUES = ['Pending', 'Approved', 'Rejected', 'Archived', 'All'] as const;
export type TimeOffQueue = (typeof TIME_OFF_QUEUES)[number];

export const TIME_OFF_QUEUE_LABEL: Record<TimeOffQueue, string> = {
  Pending: 'PENDING',
  Approved: 'APPROVED',
  Rejected: 'REJECTED',
  Archived: 'ARCHIVED',
  All: 'ALL',
};

/** The `where` of one queue. */
export const timeOffQueueFilter = (queue: TimeOffQueue): Record<string, unknown> => {
  if (queue === 'All') return {};
  if (queue === 'Archived') return { IsArchived: true };
  return { Status: queue, IsArchived: false };
};

export const timeOffQueues = TIME_OFF_QUEUES.map((value) => ({
  value,
  filter: timeOffQueueFilter(value),
}));
